import * as React from "react";
import { Box, createStyles, makeStyles } from "@material-ui/core";

import { Button, Image } from "components";
import { useAssetDetailData } from "containers/AssetDetail/hooks";
import { formatCurrencyAmount } from "lib/format";
import { BaseAmountSource } from "services/listings/types";
import theme from "theme";

import CreateEditProxyModal from "../CreateEditProxyModal";
import { offerButtonStyle } from "./OfferStatus";

const useStyles = makeStyles(() =>
  createStyles({
    offerButton: offerButtonStyle,
    fontWeightMedium: {
      fontWeight: 400,
    },
    offerRow: {
      backgroundColor: theme.custom.palette.gray.light,
      opacity: 1,
      display: "flex",
      flexDirection: "row",
      alignItems: "stretch",
      textAlign: "left",
      margin: theme.spacing(1, 0),
      boxShadow: theme.shadows[3],
      borderRadius: theme.spacing(0.375),
      width: "100%",
      "& > div:first-of-type": {
        display: "flex",
        width: 35,
        borderRight: "1px solid #e1e1e3",
      },
      "& > div:last-child": {
        width: "100%",
        padding: theme.spacing(1.25),
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      },
      "& > div:last-child > div:first-of-type > div:first-of-type": {
        fontSize: 21,
        fontWeight: theme.typography.fontWeightMedium,
        margin: theme.spacing(0.625, 0),
      },
      "& > div:last-child > div:first-of-type > div:last-child": {
        fontSize: 16,
        marginTop: theme.spacing(0.25),
        marginBottom: 0,
        [theme.breakpoints.down("xs")]: {
          fontSize: 14,
        },
      },
    },
    offerUserImage: {
      margin: "auto",
      width: "60%",
    },
  }),
);

interface ProxyRowProps {
  buyNowPrice: number;
  highestOpenBuyerOfferAmount: number;
  isMarketplaceMedianDisabled: boolean;
  listingId: number;
  listingProxyIncrementAmount: number;
  ltm: number;
  marketplaceMedian: string | null;
  marketplaceMedianMultiplier: number;
  marketplaceMedianSource: BaseAmountSource;
  userHasActiveOffer: boolean;
}

const ProxyRow: React.FC<ProxyRowProps> = ({
  buyNowPrice,
  highestOpenBuyerOfferAmount,
  isMarketplaceMedianDisabled,
  listingId,
  listingProxyIncrementAmount,
  ltm,
  marketplaceMedian,
  marketplaceMedianMultiplier,
  marketplaceMedianSource,
}) => {
  const classes = useStyles();
  const { proxy } = useAssetDetailData(listingId);
  const [isEditProxyModalOpen, setIsEditProxyModalOpen] = React.useState(false);

  return (
    <>
      {isEditProxyModalOpen && (
        <CreateEditProxyModal
          onClose={() => setIsEditProxyModalOpen(false)}
          marketplaceMedianSource={marketplaceMedianSource}
          marketplaceMedianMultiplier={marketplaceMedianMultiplier}
          marketplaceMedian={marketplaceMedian}
          buyNowPrice={buyNowPrice}
          highestOpenBuyerOfferAmount={highestOpenBuyerOfferAmount}
          isMarketplaceMedianDisabled={isMarketplaceMedianDisabled}
          listingId={listingId}
          listingProxyIncrementAmount={listingProxyIncrementAmount}
          ltm={ltm}
        />
      )}
      <Box display="flex">
        <Box className={classes.offerRow}>
          <div>
            <Image
              name="orderbook-user.svg"
              className={classes.offerUserImage}
            />
          </div>
          <div>
            {formatCurrencyAmount("USD", proxy.amount)}
            <Button
              className={`${classes.offerButton} ${classes.fontWeightMedium}`}
              customColor="white"
              variant="outlined"
              onClick={() => setIsEditProxyModalOpen(true)}
            >
              Edit Proxy
            </Button>
          </div>
        </Box>
      </Box>
    </>
  );
};

export default ProxyRow;
